import React, { useEffect, useState } from "react";
import Spinner from "components/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";

export default function Image({
  src,
  onLoad = () => {},
  onError = () => {},
  ...props
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (isLoaded && !isError && typeof onLoad === "function") {
      onLoad();
    }

    if (isError && typeof onError === "function") {
      onError();
    }
  }, [isLoaded, isError]);

  return (
    <div className="flex-grow flex justify-center items-center h-full">
      {!isLoaded && !isError && (
        <div className="flex justify-center items-center h-full">
          <Spinner />
        </div>
      )}

      {isError && (
        <div className="flex justify-center items-center h-full">
          <FontAwesomeIcon icon={faImage} />
        </div>
      )}

      <img
        style={{
          maxHeight: "100%",
          display: isLoaded && !isError ? "block" : "none",
        }}
        {...props}
        className="w-full h-full object-contain block transition-opacity duration-300"
        onLoad={() => {
          setIsLoaded(true);
        }}
        onError={() => {
          setIsError(true);
        }}
        alt={props?.alt}
        src={src}
      />
    </div>
  );
}
